import { FunctionComponent, useEffect } from 'react'
import { useLocation } from 'react-router'

import CustomLayout from '@/components/CustomLayout'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { useGroupConsultationContext } from '@/modules/MyCalls/contexts/consultationGroupContext'
import { useStyles } from './styles'
import { toast } from '@conexasaude/hero'
import { useHistory } from 'react-router-dom'

export type GroupVideoRoomParams = {
  callId: number
  callStatus: string
  isHost: boolean
  meetingId: string
  meetingServiceType: string
  meetingUrl: string
  userId: number
}

const GroupVideoRoom: FunctionComponent = () => {
  const location = useLocation<GroupVideoRoomParams>()
  const { groupConsultationData } = useGroupConsultationContext()
  const history = useHistory()

  const { clinic } = useAuthContext()
  const styles = useStyles()

  useEffect(() => {
    if (!location?.state) {
      toast('O profisisonal não está na chamada, tente novamente mais tarde.', {
        variant: 'danger',
        autoClose: 5000,
      })
      setTimeout(() => {
        return history.push('/meus-atendimentos')
      }, 3000)
    }
  }, [location?.state, history])

  return (
    <CustomLayout>
      <div css={styles.container}>
        <div className="row">
          <div className="col-12" css={styles.meetingHeader}>
            <h3>Videochamada</h3>

            <ul>
              <li>
                Tipo de consulta:{' '}
                <span>{groupConsultationData?.description}</span>
              </li>
              <li>
                Especialidade:{' '}
                <span>{groupConsultationData?.professionalSpecialty}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className={`col-12 ${clinic?.canChat ? 'col-lg-8' : ''}`}>
            <iframe
              src={location?.state?.meetingUrl}
              width="100%"
              height="550"
              name="meetConference"
              allow="camera; microphone; display-capture;"
              allowFullScreen
            />
          </div>

          {clinic?.canChat && (
            <div className="col-12 col-lg-4" css={styles.chatWrapper}></div>
          )}
        </div>
      </div>
    </CustomLayout>
  )
}

export default GroupVideoRoom
